import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart",
  "use": "icon-cart-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"icon-cart\"><path d=\"M6.836 14.355a1.822 1.822 0 1 1 0 3.645 1.822 1.822 0 0 1 0-3.645Zm6.832 0a1.822 1.822 0 1 1 0 3.645 1.822 1.822 0 0 1 0-3.645Zm0 1a.822.822 0 1 0 0 1.645.822.822 0 0 0 0-1.645Zm-6.832 0a.822.822 0 1 0 0 1.645.822.822 0 0 0 0-1.645ZM4.632 3.563h14.58l-3.246 9.656H4.904L2.625 1.368 0 1.365.911 0h2.843l.878 3.563Zm1.401 8.29h8.986l2.22-6.922H4.895l1.138 6.922Z\" fill=\"#003C71\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol